// Browser bindings for the pure client modules (DOM only; not imported by Node tests).
import type { RealtimeTimers } from './realtime.js';

export const browserTimers: RealtimeTimers = {
  setTimeout: (fn, ms) => window.setTimeout(fn, ms),
  clearTimeout: (h) => window.clearTimeout(h as number),
  setInterval: (fn, ms) => window.setInterval(fn, ms),
  clearInterval: (h) => window.clearInterval(h as number),
};

/** Same-origin WebSocket URL for a path. */
export function wsUrl(path: string): string {
  return (location.protocol === 'https:' ? 'wss://' : 'ws://') + location.host + path;
}
